import { createBrowserInspector as _createBrowserInspector } from '@statelyai/inspect';

export function createBrowserInspector(options?: Parameters<typeof _createBrowserInspector>[0]) {
  switch (window.CONFIG.environment) {
    case 'development':
      return _createBrowserInspector({ autoStart: false, ...options });

    case 'sandbox':
      return _createBrowserInspector({ autoStart: false, ...options });

    default:
      return undefined;
  }
}
